import { render, staticRenderFns } from "./NavBarTournamentButton.vue?vue&type=template&id=1da786ec&scoped=true&"
import script from "./NavBarTournamentButton.vue?vue&type=script&lang=js&"
export * from "./NavBarTournamentButton.vue?vue&type=script&lang=js&"
import style0 from "./NavBarTournamentButton.vue?vue&type=style&index=0&id=1da786ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da786ec",
  null
  
)

export default component.exports